// extracted by mini-css-extract-plugin
export default {"title":"Sidebar_title__OwtZy","menu":"Sidebar_menu__3tatJ","navMenu":"Sidebar_navMenu__GVP7w","closeArrow":"Sidebar_closeArrow__ywnq7","openArrow":"Sidebar_openArrow__0HRqd"};